import React from 'react'

const SocialIconsFooter = () => {
    return (
        <section className="dark-bg2 small-padding order-wrap">
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <h3>Find us on social networks : </h3>
                    </div>
                    <div className="col-md-5 float-right">
                    <ul >
                            <li><a href="https://www.linkedin.com/company/pragicts/" target="_blank"><i aria-label='Linkedin' className="fab fa-linkedin"></i></a></li>
                   
                            <li><a href="https://www.youtube.com/@pragicts" target="_blank"><i aria-label='YouTube' className="fab fa-youtube"></i></a></li>

                {/* <li><a rel="noreferrer noopener" href="https://www.linkedin.com/company/pragicts/" target="_blank"><i aria-label='Linkedin' className="fab fa-linkedin"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.facebook.com/pragicts.ltd" target="_blank"><i aria-label='Facebook' className="fab fa-facebook-f"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.instagram.com/pragicts/" target="_blank"><i aria-label='Instagram' className="fab fa-instagram"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://twitter.com/pragictsltd" target="_blank"><i aria-label='Twitter' className="fab fa-twitter"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.pinterest.com/pragicts" target="_blank"><i aria-label='Pinterest' className="fab fa-pinterest"></i></a></li>
                    <li><a rel="noreferrer noopener" href="https://www.youtube.com/channel/UCNYbr4DHBPqeXslkZ6hRruQ" target="_blank"><i aria-label='YouTube' className="fab fa-youtube"></i></a></li>*/}
                </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SocialIconsFooter
